import { useContext, useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { findTingkatRisiko, formatDate } from "../../../constants/helper";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl } from "../../../contexts/ContextProvider";
import { Loader } from "../../../components";
import LogoPerusahaanSpFidusiaBlackAndWhite from "../../../assets/LogoPerusahaanSpFidusiaBlackAndWhite.jpg";
import { Container, Card, Form, Row, Col } from "react-bootstrap";
import {
  Box,
  ButtonGroup,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  CardHeader,
  CardActionArea,
  CardMedia,
} from "@mui/material";
import Carousel from "react-elastic-carousel";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import PanoramaIcon from "@mui/icons-material/Panorama";
import SearchIcon from "@mui/icons-material/Search";
import PrintIcon from "@mui/icons-material/Print";
import { useReactToPrint } from "react-to-print";
import useScreenWidth from "../../../hooks/useScreenWidth";

const TampilPengajuanFidusia = () => {
  const screenSize = useScreenWidth();
  const reportTemplateRef = useRef(null);
  const { user, dispatch, setting } = useContext(AuthContext);
  const [customerId, setCustomerId] = useState("");
  // Data Customer
  const [cifCustomer, setCifCustomer] = useState("");
  const [nikCustomer, setNikCustomer] = useState("");
  const [noKkCustomer, setNoKkCustomer] = useState("");
  const [namaCustomer, setNamaCustomer] = useState("");
  const [tempatLahirCustomer, setTempatLahirCustomer] = useState("");
  const [tanggalLahirCustomer, setTanggalLahirCustomer] = useState("");
  const [jenisKelaminCustomer, setJenisKelaminCustomer] = useState("");
  const [agamaCustomer, setAgamaCustomer] = useState("");
  const [noTeleponCustomer, setNoTeleponCustomer] = useState("");
  const [alamatCustomer, setAlamatCustomer] = useState("");
  const [alamatTTCustomer, setAlamatTTCustomer] = useState("");
  const [kodeProvinsi, setKodeProvinsi] = useState("");
  const [kodeProvinsiTT, setKodeProvinsiTT] = useState("");
  const [kodeKabupaten, setKodeKabupaten] = useState("");
  const [kodeKabupatenTT, setKodeKabupatenTT] = useState("");
  const [kodeKecamatan, setKodeKecamatan] = useState("");
  const [kodeKecamatanTT, setKodeKecamatanTT] = useState("");
  const [kodeKelurahan, setKodeKelurahan] = useState("");
  const [kodeKelurahanTT, setKodeKelurahanTT] = useState("");
  const [kodePos, setKodePos] = useState("");
  const [kodePosTT, setKodePosTT] = useState("");
  const [statusPerkawinanCustomer, setStatusPerkawinanCustomer] = useState("");
  const [pekerjaanCustomer, setPekerjaanCustomer] = useState("");
  const [jabatanCustomer, setJabatanCustomer] = useState("");
  const [linkMapsSurvey, setLinkMapsSurvey] = useState("");
  const [tujuanPenggunaanDana, setTujuanPenggunaanDana] = useState("");
  const [kewarganegaraanCustomer, setKewarganegaraanCustomer] = useState("");
  const [jenisResikoAju, setJenisResikoAju] = useState("");
  const [tingkatRisiko, setTingkatRisiko] = useState("");
  const [tingkatRisikoData, setTingkatRisikoData] = useState({});
  const [ketResikoAju, setKetResikoAju] = useState("");

  // Data Penjamin
  const [alamatSama, setAlamatSama] = useState(false);
  const [cifPenjamin, setCifPenjamin] = useState("");
  const [nikPenjamin, setNikPenjamin] = useState("");
  const [noKkPenjamin, setNoKkPenjamin] = useState("");
  const [namaPenjamin, setNamaPenjamin] = useState("");
  const [tempatLahirPenjamin, setTempatLahirPenjamin] = useState("");
  const [tanggalLahirPenjamin, setTanggalLahirPenjamin] = useState("");
  const [jenisKelaminPenjamin, setJenisKelaminPenjamin] = useState("");
  const [agamaPenjamin, setAgamaPenjamin] = useState("");
  const [noTeleponPenjamin, setNoTeleponPenjamin] = useState("");

  // DATA REFERENSI
  const [namaRefRegister, setNamaRefRegister] = useState("");
  const [alamatRefRegister, setAlamatRefRegister] = useState("");
  const [teleponRefRegister, setTeleponRefRegister] = useState("");
  const [hubunganRefRegister, setHubunganRefRegister] = useState("");
  // const [statusPerkawinanRefRegister, setStatusPerkawinanRefRegister] =
  //   useState("");
  const [namaRef2Register, setNamaRef2Register] = useState("");
  const [alamatRef2Register, setAlamatRef2Register] = useState("");
  const [teleponRef2Register, setTeleponRef2Register] = useState("");
  const [hubunganRef2Register, setHubunganRef2Register] = useState("");
  // const [statusPerkawinanRef2Register, setStatusPerkawinanRef2Register] =
  //   useState("");
  const [namaRef3Register, setNamaRef3Register] = useState("");
  const [alamatRef3Register, setAlamatRef3Register] = useState("");
  const [teleponRef3Register, setTeleponRef3Register] = useState("");
  const [hubunganRef3Register, setHubunganRef3Register] = useState("");
  // const [statusPerkawinanRef3Register, setStatusPerkawinanRef3Register] =
  //   useState("");
  const [alamatPenjamin, setAlamatPenjamin] = useState("");
  const [kodeProvinsiPenjamin, setKodeProvinsiPenjamin] = useState("");
  const [kodeKabupatenPenjamin, setKodeKabupatenPenjamin] = useState("");
  const [kodeKecamatanPenjamin, setKodeKecamatanPenjamin] = useState("");
  const [kodeKelurahanPenjamin, setKodeKelurahanPenjamin] = useState("");
  const [kodePosPenjamin, setKodePosPenjamin] = useState("");
  const [statusPerkawinanPenjamin, setStatusPerkawinanPenjamin] = useState("");
  const [pekerjaanPenjamin, setPekerjaanPenjamin] = useState("");
  const [kewarganegaraanPenjamin, setKewarganegaraanPenjamin] = useState("");

  // Data Pinjaman
  const [noAju, setNoAju] = useState("");
  const [noPerjanjian, setNoPerjanjian] = useState("");
  const [kategori, setKategori] = useState("");
  const [pinjamanAju, setPinjamanAju] = useState(0);
  const [angPerBulan, setAngPerBulan] = useState(0);
  const [kodeMarketing, setKodeMarketing] = useState("");
  const [tanggalAju, setTanggalAju] = useState(new Date());
  const [tglAng, setTglAng] = useState("");
  const [tglAngAkhir, setTglAngAkhir] = useState("");
  const [tenor, setTenor] = useState(0);
  const [bungaPerTahun, setBungaPerTahun] = useState(0);
  const [totalPiutang, setTotalPiutang] = useState(0);
  const [kodeSurveyor, setKodeSurveyor] = useState("");
  const [kodeCOA, setKodeCOA] = useState("");

  // Data Kendaraan
  const [kodeTipe, setKodeTipe] = useState("");
  const [tahun, setTahun] = useState("");
  const [noRangka, setNoRangka] = useState("");
  const [kodeWarna, setKodeWarna] = useState("");
  const [noBpkb, setNoBpkb] = useState("");
  const [tglStnk, setTglStnk] = useState("");
  const [bpkbAN, setBpkbAN] = useState("");
  const [noMesin, setNoMesin] = useState("");
  const [isi, setIsi] = useState("");
  const [merk, setMerk] = useState("");
  const [nopol, setNopol] = useState("");

  // Data Penilaian
  const [hargaPasarSetempatOtr, setHargaPasarSetempatOtr] = useState("");
  const [taksiran, setTaksiran] = useState("");
  const [maksimalPemberianPinjaman, setMaksimalPemberianPinjaman] =
    useState("");

  // Asuransi
  const [noFidusia, setNoFidusia] = useState("");
  const [nilaiPertanggungan, setNilaiPertanggungan] = useState(0);
  const [noAsuransi, setNoAsuransi] = useState("");

  const [keterangan, setKeterangan] = useState("");

  const [isPost, setIsPost] = useState("");
  let [gambar, setGambar] = useState([]);
  const [previewPdfFormulir, setPreviewPdfFormulir] = useState(false);

  // Data Survey
  const [nikCustomerSurvey, setNikCustomerSurvey] = useState("");
  const [namaCustomerSurvey, setNamaCustomerSurvey] = useState("");
  const [namaPanggilanCustomerSurvey, setNamaPanggilanCustomerSurvey] =
    useState("");
  const [tempatLahirCustomerSurvey, setTempatLahirCustomerSurvey] =
    useState("");
  const [tanggalLahirCustomerSurvey, setTanggalLahirCustomerSurvey] =
    useState("");
  const [noTeleponCustomerSurvey, setNoTeleponCustomerSurvey] = useState("");
  const [alamatCustomerSurvey, setAlamatCustomerSurvey] = useState("");
  const [alamatTTCustomerSurvey, setAlamatTTCustomerSurvey] = useState("");
  const [statusPerkawinanCustomerSurvey, setStatusPerkawinanCustomerSurvey] =
    useState("");

  const [namaPerusahaanCustomerSurvey, setNamaPerusahaanCustomerSurvey] =
    useState("");
  const [bidangUsahaCustomerSurvey, setBidangUsahaCustomerSurvey] =
    useState("");
  const [jabatanCustomerSurvey, setJabatanCustomerSurvey] = useState("");
  const [alamatPerusahaanCustomerSurvey, setAlamatPerusahaanCustomerSurvey] =
    useState("");
  const [
    noTeleponPerusahaanCustomerSurvey,
    setNoTeleponPerusahaanCustomerSurvey,
  ] = useState("");
  const [lamaKerjaCustomerSurvey, setLamaKerjaCustomerSurvey] = useState("");
  const [pendapatanLainCustomerSurvey, setPendapatanLainCustomerSurvey] =
    useState("0");

  // Data Penjamin
  const [nikPenjaminSurvey, setNikPenjaminSurvey] = useState("");
  const [namaPenjaminSurvey, setNamaPenjaminSurvey] = useState("");
  const [tempatLahirPenjaminSurvey, setTempatLahirPenjaminSurvey] =
    useState("");
  const [noTeleponPenjaminSurvey, setNoTeleponPenjaminSurvey] = useState("");
  const [alamatPenjaminSurvey, setAlamatPenjaminSurvey] = useState("");
  const [namaPerusahaanPenjaminSurvey, setNamaPerusahaanPenjaminSurvey] =
    useState("");
  const [alamatPerusahaanPenjaminSurvey, setAlamatPerusahaanPenjaminSurvey] =
    useState("");
  const [pekerjaanPenjaminSurvey, setPekerjaanPenjaminSurvey] = useState("");
  const [lamaKerjaPenjaminSurvey, setLamaKerjaPenjaminSurvey] = useState("");
  const [hubunganPenjaminSurvey, setHubunganPenjaminSurvey] = useState("");

  const [uangMukaSurvey, setUangMukaSurvey] = useState("");
  const [pinjamanAjuSurvey, setPinjamanAjuSurvey] = useState("");
  const [angPerBulanSurvey, setAngPerBulanSurvey] = useState("");
  const [tenorSurvey, setTenorSurvey] = useState("");

  // DATA KENDARAAN
  const [merkSurvey, setMerkSurvey] = useState("");
  const [tipeSurvey, setTipeSurvey] = useState("");
  const [tahunSurvey, setTahunSurvey] = useState("");
  const [warnaSurvey, setWarnaSurvey] = useState("");
  const [nopolSurvey, setNopolSurvey] = useState("");
  const [noRangkaSurvey, setNoRangkaSurvey] = useState("");
  const [noMesinSurvey, setNoMesinSurvey] = useState("");
  const [tglStnkSurvey, setTglStnkSurvey] = useState("");
  const [bpkbANSurvey, setBpkbANSurvey] = useState("");
  const [bpkbAlamatSurvey, setBpkbAlamatSurvey] = useState("");

  // DATA REFERENSI
  const [namaRefRegisterSurvey, setNamaRefRegisterSurvey] = useState("");
  const [alamatRefRegisterSurvey, setAlamatRefRegisterSurvey] = useState("");
  const [teleponRefRegisterSurvey, setTeleponRefRegisterSurvey] = useState("");
  const [hubunganRefRegisterSurvey, setHubunganRefRegisterSurvey] =
    useState("");
  // const [
  //   statusPerkawinanRefRegisterSurvey,
  //   setStatusPerkawinanRefRegisterSurvey,
  // ] = useState("");
  const [namaRef2RegisterSurvey, setNamaRef2RegisterSurvey] = useState("");
  const [alamatRef2RegisterSurvey, setAlamatRef2RegisterSurvey] = useState("");
  const [teleponRef2RegisterSurvey, setTeleponRef2RegisterSurvey] =
    useState("");
  const [hubunganRef2RegisterSurvey, setHubunganRef2RegisterSurvey] =
    useState("");
  // const [
  //   statusPerkawinanRef2RegisterSurvey,
  //   setStatusPerkawinanRef2RegisterSurvey,
  // ] = useState("");
  const [namaRef3RegisterSurvey, setNamaRef3RegisterSurvey] = useState("");
  const [alamatRef3RegisterSurvey, setAlamatRef3RegisterSurvey] = useState("");
  const [teleponRef3RegisterSurvey, setTeleponRef3RegisterSurvey] =
    useState("");
  const [hubunganRef3RegisterSurvey, setHubunganRef3RegisterSurvey] =
    useState("");
  // const [
  //   statusPerkawinanRef3RegisterSurvey,
  //   setStatusPerkawinanRef3RegisterSurvey,
  // ] = useState("");

  // DATA PINJAMAN
  const [hargaOtrSurvey, setHargaOtrSurvey] = useState("");
  const [tglJtTempoSurvey, setTglJtTempoSurvey] = useState(null);
  const [tujuanPenggunaanDanaSurvey, setTujuanPenggunaanDanaSurvey] =
    useState("");
  const [pendinganPengurusanSurvey, setPendinganPengurusanSurvey] =
    useState("");
  const [kodeMarketingSurvey, setKodeMarketingSurvey] = useState("");
  const [kodeSurveyorSurvey, setKodeSurveyorSurvey] = useState("");

  const [keteranganSurvey, setKeteranganSurvey] = useState("");

  const [denahLokasiSurveySurvey, setDenahLokasiSurveySurvey] = useState("");
  const [ttdSurveySurvey, setTtdSurveySurvey] = useState("");

  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [isEditable, setIsEditable] = useState(false);

  const breakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 550, itemsToShow: 2 },
    { width: 768, itemsToShow: 3 },
    { width: 1200, itemsToShow: 4 },
  ];

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const countDateDurationReview = (tenor, date) => {
    var tempDate = new Date(date);
    var final = tempDate.setMonth(tempDate.getMonth() + parseInt(tenor));
    setTglAngAkhir(formatDate(final));
  };

  useEffect(() => {
    getPengajuanFidusiaById();
  }, []);

  const getPengajuanFidusiaById = async () => {
    setLoading(true);
    const response = await axios.post(`${tempUrl}/pengajuanFidusias/${id}`, {
      _id: user.id,
      token: user.token,
    });
    setCustomerId(response.data.customer.id);
    // Data Customer
    setCifCustomer(response.data.customer.cifCustomer);
    setNikCustomer(response.data.customer.nikCustomer);
    setNoKkCustomer(response.data.customer.noKkCustomer);
    setNamaCustomer(response.data.customer.namaCustomer);
    setTempatLahirCustomer(response.data.customer.tempatLahirCustomer);
    setTanggalLahirCustomer(
      formatDate(response.data.customer.tanggalLahirCustomer)
    );
    setJenisKelaminCustomer(response.data.customer.jenisKelaminCustomer);
    setAgamaCustomer(response.data.customer.agamaCustomer);
    setNoTeleponCustomer(response.data.customer.noTeleponCustomer);
    setAlamatCustomer(response.data.customer.alamatCustomer);
    setAlamatTTCustomer(response.data.customer.alamatTTCustomer);
    setKodeProvinsi(response.data.customer.provinsis.namaProvinsi);
    setKodeProvinsiTT(response.data.customer.provinsisTT.namaProvinsi);
    setKodeKabupaten(response.data.customer.kabupaten.namaKabupaten);
    setKodeKabupatenTT(response.data.customer.kabupatenTT.namaKabupaten);
    setKodeKecamatan(response.data.customer.kecamatan.namaKecamatan);
    setKodeKecamatanTT(response.data.customer.kecamatanTT.namaKecamatan);
    setKodeKelurahan(response.data.customer.kelurahan.namaKelurahan);
    setKodeKelurahanTT(response.data.customer.kelurahanTT.namaKelurahan);
    setKodePos(response.data.customer.kelurahan.kodePos);
    setKodePosTT(response.data.customer.kelurahanTT.kodePos);
    setStatusPerkawinanCustomer(
      response.data.customer.statusPerkawinanCustomer
    );
    setPekerjaanCustomer(response.data.customer.pekerjaanCustomer);
    setJabatanCustomer(response.data.customer.jabatanCustomer);
    setKewarganegaraanCustomer(response.data.customer.kewarganegaraanCustomer);
    setJenisResikoAju(response.data.jenisResikoAju);
    setTingkatRisiko(
      `${response.data.tingkatrisiko.kodeTingkatRisiko} - ${response.data.tingkatrisiko.namaTingkatRisiko}`
    );
    setTingkatRisikoData(response.data.tingkatrisiko);
    setKetResikoAju(response.data.ketResikoAju);

    // Data Penjamin
    setNikPenjamin(response.data.nikPenjamin);
    setNoKkPenjamin(response.data.noKkPenjamin);
    setNamaPenjamin(response.data.namaPenjamin);
    setTempatLahirPenjamin(response.data.tempatLahirPenjamin);
    setTanggalLahirPenjamin(formatDate(response.data.tanggalLahirPenjamin));
    setJenisKelaminPenjamin(response.data.jenisKelaminPenjamin);
    setAgamaPenjamin(response.data.agamaPenjamin);
    setNoTeleponPenjamin(response.data.noTeleponPenjamin);
    setNamaRefRegister(response.data.namaRefRegister);
    setAlamatRefRegister(response.data.alamatRefRegister);
    setTeleponRefRegister(response.data.teleponRefRegister);
    setHubunganRefRegister(response.data.hubunganRefRegister);
    // setStatusPerkawinanRefRegister(response.data.statusPerkawinanRefRegister);
    setNamaRef2Register(response.data.namaRef2Register);
    setAlamatRef2Register(response.data.alamatRef2Register);
    setTeleponRef2Register(response.data.teleponRef2Register);
    setHubunganRef2Register(response.data.hubunganRef2Register);
    // setStatusPerkawinanRef2Register(response.data.statusPerkawinanRef2Register);
    setNamaRef3Register(response.data.namaRef3Register);
    setAlamatRef3Register(response.data.alamatRef3Register);
    setTeleponRef3Register(response.data.teleponRef3Register);
    setHubunganRef3Register(response.data.hubunganRef3Register);
    // setStatusPerkawinanRef3Register(response.data.statusPerkawinanRef3Register);
    setAlamatPenjamin(response.data.alamatPenjamin);
    setKodeProvinsiPenjamin(response.data.provinsisPenjamin.namaProvinsi);
    setKodeKabupatenPenjamin(response.data.kabupatenPenjamin.namaKabupaten);
    setKodeKecamatanPenjamin(response.data.kecamatanPenjamin.namaKecamatan);
    setKodeKelurahanPenjamin(response.data.kelurahanPenjamin.namaKelurahan);
    setKodePosPenjamin(response.data.kelurahanPenjamin.kodePos);
    setStatusPerkawinanPenjamin(response.data.statusPerkawinanPenjamin);
    setPekerjaanPenjamin(response.data.pekerjaanPenjamin);
    setKewarganegaraanPenjamin(response.data.kewarganegaraanPenjamin);

    // Data Pinjaman
    setNoAju(response.data.noAju);
    setNoPerjanjian(response.data.noPerjanjian);
    setKategori(response.data.kategori);
    setPinjamanAju(response.data.pinjamanAju);
    setAngPerBulan(response.data.angPerBulan);
    setKodeMarketing(
      `${response.data.marketing.kodeMarketing} - ${response.data.marketing.namaMarketing}`
    );
    setTanggalAju(formatDate(response.data.tanggalAju));
    setTglAng(formatDate(response.data.tglAng));
    countDateDurationReview(response.data.tenor, response.data.tglAng);
    setTenor(response.data.tenor);
    setBungaPerTahun(response.data.bungaPerTahun);
    setTotalPiutang(response.data.totalPiutang);
    setKodeSurveyor(
      `${response.data.surveyor.kodeSurveyor} - ${response.data.surveyor.namaSurveyor}`
    );
    setKodeCOA(`${response.data.coa.kodeCOA} - ${response.data.coa.namaCOA}`);

    // Data Kendaraan
    setKodeTipe(response.data.tipe.kodeTipe);
    setTahun(response.data.tahun);
    setNoRangka(response.data.noRangka);
    setKodeWarna(response.data.warna.namaWarna);
    setNoBpkb(response.data.noBpkb);
    setTglStnk(formatDate(response.data.tglStnk));
    setBpkbAN(response.data.bpkbAN);
    setNoMesin(response.data.noMesin);
    setIsi(response.data.isi);
    setMerk(response.data.merk);
    setNopol(response.data.nopol);

    // Data Penilaian
    setHargaPasarSetempatOtr(response.data.hargaPasarSetempatOtr);
    setTaksiran(response.data.taksiran);
    setMaksimalPemberianPinjaman(response.data.maksimalPemberianPinjaman);

    // Data Asuransi
    setNoFidusia(response.data.noFidusia);
    setNilaiPertanggungan(response.data.nilaiPertanggungan);
    setNoAsuransi(response.data.noAsuransi);

    const findSurveyFidusiaByCustomerId = await axios.post(
      `${tempUrl}/surveyFidusiaByCustomerId`,
      {
        customerId: response.data.customer.id,
        _id: user.id,
        token: user.token,
        kodeCabang: user.cabang.id,
      }
    );
    if (findSurveyFidusiaByCustomerId.data) {
      setLinkMapsSurvey(findSurveyFidusiaByCustomerId.data.linkMapsSurvey);
      setTujuanPenggunaanDana(
        findSurveyFidusiaByCustomerId.data.tujuanPenggunaanDana
      );
      setKeterangan(findSurveyFidusiaByCustomerId.data.keterangan);

      setNikCustomerSurvey(
        findSurveyFidusiaByCustomerId.data.registerfidusia.customer.nikCustomer
      );
      setNamaCustomerSurvey(
        findSurveyFidusiaByCustomerId.data.registerfidusia.customer.namaCustomer
      );
      setNamaPanggilanCustomerSurvey(
        findSurveyFidusiaByCustomerId.data.registerfidusia.customer
          .namaPanggilanCustomer
      );
      setTempatLahirCustomerSurvey(
        findSurveyFidusiaByCustomerId.data.registerfidusia.customer
          .tempatLahirCustomer
      );
      setTanggalLahirCustomerSurvey(
        formatDate(
          findSurveyFidusiaByCustomerId.data.registerfidusia.customer
            .tanggalLahirCustomer
        )
      );
      setNoTeleponCustomerSurvey(
        findSurveyFidusiaByCustomerId.data.registerfidusia.customer
          .noTeleponCustomer
      );
      setAlamatCustomerSurvey(
        findSurveyFidusiaByCustomerId.data.registerfidusia.customer
          .alamatCustomer
      );
      setAlamatTTCustomerSurvey(
        findSurveyFidusiaByCustomerId.data.registerfidusia.customer
          .alamatTTCustomer
      );
      setStatusPerkawinanCustomerSurvey(
        findSurveyFidusiaByCustomerId.data.registerfidusia.customer
          .statusPerkawinanCustomer
      );

      setNamaPerusahaanCustomerSurvey(
        findSurveyFidusiaByCustomerId.data.registerfidusia.customer
          .namaPerusahaanCustomer
      );
      setBidangUsahaCustomerSurvey(
        findSurveyFidusiaByCustomerId.data.registerfidusia.customer
          .bidangUsahaCustomer
      );
      setJabatanCustomerSurvey(
        findSurveyFidusiaByCustomerId.data.registerfidusia.customer
          .jabatanCustomer
      );
      setAlamatPerusahaanCustomerSurvey(
        findSurveyFidusiaByCustomerId.data.registerfidusia.customer
          .alamatPerusahaanCustomer
      );
      setNoTeleponPerusahaanCustomerSurvey(
        findSurveyFidusiaByCustomerId.data.registerfidusia.customer
          .noTeleponPerusahaanCustomer
      );
      setLamaKerjaCustomerSurvey(
        findSurveyFidusiaByCustomerId.data.registerfidusia.customer
          .lamaKerjaCustomer
      );
      setPendapatanLainCustomerSurvey(
        findSurveyFidusiaByCustomerId.data.registerfidusia.customer
          .pendapatanLainCustomer
      );

      setNikPenjaminSurvey(
        findSurveyFidusiaByCustomerId.data.registerfidusia.nikPenjamin
      );
      setNamaPenjaminSurvey(
        findSurveyFidusiaByCustomerId.data.registerfidusia.namaPenjamin
      );
      setTempatLahirPenjaminSurvey(
        findSurveyFidusiaByCustomerId.data.registerfidusia.tempatLahirPenjamin
      );
      setNoTeleponPenjaminSurvey(
        findSurveyFidusiaByCustomerId.data.registerfidusia.noTeleponPenjamin
      );
      setAlamatPenjaminSurvey(
        findSurveyFidusiaByCustomerId.data.registerfidusia.alamatPenjamin
      );
      setNamaPerusahaanPenjaminSurvey(
        findSurveyFidusiaByCustomerId.data.registerfidusia
          .namaPerusahaanPenjamin
      );
      setAlamatPerusahaanPenjaminSurvey(
        findSurveyFidusiaByCustomerId.data.registerfidusia
          .alamatPerusahaanPenjamin
      );
      setPekerjaanPenjaminSurvey(
        findSurveyFidusiaByCustomerId.data.registerfidusia.pekerjaanPenjamin
      );
      setLamaKerjaPenjaminSurvey(
        findSurveyFidusiaByCustomerId.data.registerfidusia.lamaKerjaPenjamin
      );
      setHubunganPenjaminSurvey(
        findSurveyFidusiaByCustomerId.data.registerfidusia.hubunganPenjamin
      );

      setUangMukaSurvey(
        findSurveyFidusiaByCustomerId.data.registerfidusia.uangMuka
      );
      setPinjamanAjuSurvey(
        findSurveyFidusiaByCustomerId.data.registerfidusia.pinjamanAju
      );
      setAngPerBulanSurvey(
        findSurveyFidusiaByCustomerId.data.registerfidusia.angPerBulan
      );
      setTenorSurvey(findSurveyFidusiaByCustomerId.data.registerfidusia.tenor);

      // DATA KENDARAAN
      setMerkSurvey(findSurveyFidusiaByCustomerId.data.merk);
      setTipeSurvey(findSurveyFidusiaByCustomerId.data.tipe);
      setTahunSurvey(findSurveyFidusiaByCustomerId.data.tahun);
      setWarnaSurvey(findSurveyFidusiaByCustomerId.data.warna);
      setNopolSurvey(findSurveyFidusiaByCustomerId.data.nopol);
      setNoRangkaSurvey(findSurveyFidusiaByCustomerId.data.noRangka);
      setNoMesinSurvey(findSurveyFidusiaByCustomerId.data.noMesin);
      setTglStnkSurvey(
        findSurveyFidusiaByCustomerId.data.tglStnk &&
          formatDate(findSurveyFidusiaByCustomerId.data.tglStnk)
      );
      setBpkbANSurvey(findSurveyFidusiaByCustomerId.data.bpkbAN);
      setBpkbAlamatSurvey(findSurveyFidusiaByCustomerId.data.bpkbAlamat);

      // DATA REFERENSI
      setNamaRefRegisterSurvey(
        findSurveyFidusiaByCustomerId.data.namaRefRegister
      );
      setAlamatRefRegisterSurvey(
        findSurveyFidusiaByCustomerId.data.alamatRefRegister
      );
      setTeleponRefRegisterSurvey(
        findSurveyFidusiaByCustomerId.data.teleponRefRegister
      );
      setHubunganRefRegisterSurvey(
        findSurveyFidusiaByCustomerId.data.hubunganRefRegister
      );
      // setStatusPerkawinanRefRegisterSurvey(
      //   findSurveyFidusiaByCustomerId.data.statusPerkawinanRefRegister
      // );
      setNamaRef2RegisterSurvey(
        findSurveyFidusiaByCustomerId.data.namaRef2Register
      );
      setAlamatRef2RegisterSurvey(
        findSurveyFidusiaByCustomerId.data.alamatRef2Register
      );
      setTeleponRef2RegisterSurvey(
        findSurveyFidusiaByCustomerId.data.teleponRef2Register
      );
      setHubunganRef2RegisterSurvey(
        findSurveyFidusiaByCustomerId.data.hubunganRef2Register
      );
      // setStatusPerkawinanRef2RegisterSurvey(
      //   findSurveyFidusiaByCustomerId.data.statusPerkawinanRef2Register
      // );
      setNamaRef3RegisterSurvey(
        findSurveyFidusiaByCustomerId.data.namaRef3Register
      );
      setAlamatRef3RegisterSurvey(
        findSurveyFidusiaByCustomerId.data.alamatRef3Register
      );
      setTeleponRef3RegisterSurvey(
        findSurveyFidusiaByCustomerId.data.teleponRef3Register
      );
      setHubunganRef3RegisterSurvey(
        findSurveyFidusiaByCustomerId.data.hubunganRef3Register
      );
      // setStatusPerkawinanRef3RegisterSurvey(
      //   findSurveyFidusiaByCustomerId.data.statusPerkawinanRef3Register
      // );

      // DATA PINJAMAN
      setHargaOtrSurvey(findSurveyFidusiaByCustomerId.data.hargaOtr);
      setTglJtTempoSurvey(
        findSurveyFidusiaByCustomerId.data.tglJtTempo &&
          formatDate(findSurveyFidusiaByCustomerId.data.tglJtTempo)
      );
      setTujuanPenggunaanDanaSurvey(
        findSurveyFidusiaByCustomerId.data.tujuanPenggunaanDana
      );
      setPendinganPengurusanSurvey(
        findSurveyFidusiaByCustomerId.data.pendinganPengurusan
      );
      setKodeMarketingSurvey(
        `${findSurveyFidusiaByCustomerId.data.marketing.kodeMarketing} - ${findSurveyFidusiaByCustomerId.data.marketing.namaMarketing}`
      );
      setKodeSurveyorSurvey(
        `${findSurveyFidusiaByCustomerId.data.surveyor.kodeSurveyor} - ${findSurveyFidusiaByCustomerId.data.surveyor.namaSurveyor}`
      );

      setKeteranganSurvey(findSurveyFidusiaByCustomerId.data.keterangan);

      setDenahLokasiSurveySurvey(
        findSurveyFidusiaByCustomerId.data.denahLokasiSurvey
      );
      setTtdSurveySurvey(findSurveyFidusiaByCustomerId.data.ttdSurvey);
    }

    setIsPost(response.data.isPost);

    let tempIsEditable =
      user.id === response.data.userIdInput && response.data.noSbg === null;

    setIsEditable(tempIsEditable);

    const findGambar = await axios.post(
      `${tempUrl}/pengajuanFidusiaGambarByPengajuanFidusiaId`,
      {
        id: response.data.id,
        _id: user.id,
        token: user.token,
      }
    );
    setGambar(findGambar.data);

    setLoading(false);
  };

  const deletePengajuanFidusia = async (id) => {
    setLoading(true);
    try {
      await axios.post(`${tempUrl}/deletePengajuanFidusia/${id}`, {
        customerId,
        cifCustomer,
        _id: user.id,
        token: user.token,
        kodeCabang: user.cabang.id,
      });
      navigate("/daftarPengajuanFidusia");
    } catch (error) {
      if (error.response.data.message.includes("foreign key")) {
        alert(`${noAju} tidak bisa dihapus karena sudah ada data!`);
      }
    }
    setLoading(false);
  };

  const generatePDF = useReactToPrint({
    content: () => reportTemplateRef.current,
    documentTitle: "FormulirPermohonanAkadKredit",
  });

  if (loading) {
    return <Loader />;
  }

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  return (
    <Container>
      <h3>Fidusia</h3>
      <h5 style={{ fontWeight: 400 }}>Data Pengajuan</h5>
      <hr />
      <Button
        variant="outlined"
        color="secondary"
        onClick={() => navigate("/daftarPengajuanFidusia")}
        sx={{ marginLeft: 2, marginTop: 4 }}
      >
        {"< Kembali"}
      </Button>

      {id && (
        <Box sx={downloadButtons}>
          <ButtonGroup variant="outlined" color="secondary">
            <Button
              color="primary"
              startIcon={<SearchIcon />}
              onClick={() => {
                setPreviewPdfFormulir(!previewPdfFormulir);
              }}
            >
              FORMULIR
            </Button>
          </ButtonGroup>
        </Box>
      )}

      <Box sx={buttonModifierContainer}>
        {isPost === false && (
          <>
            <ButtonGroup variant="contained">
              {isEditable && id && (
                <>
                  <Button
                    color="primary"
                    startIcon={<EditIcon />}
                    sx={{ textTransform: "none" }}
                    onClick={() => {
                      navigate(
                        `/daftarPengajuanFidusia/pengajuanFidusia/${id}/edit`
                      );
                    }}
                  >
                    Ubah
                  </Button>
                  <Button
                    color="error"
                    startIcon={<DeleteOutlineIcon />}
                    sx={{ textTransform: "none" }}
                    onClick={handleClickOpen}
                  >
                    Hapus
                  </Button>
                </>
              )}
            </ButtonGroup>
            <Dialog
              open={open}
              onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">{`Hapus Data`}</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-slide-description">
                  {`Yakin ingin menghapus data ${noAju}?`}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => deletePengajuanFidusia(id)}>Ok</Button>
                <Button onClick={handleClose}>Cancel</Button>
              </DialogActions>
            </Dialog>
          </>
        )}

        <ButtonGroup variant="contained">
          <Button
            color="primary"
            startIcon={<EditIcon />}
            sx={{ textTransform: "none" }}
            onClick={() => {
              navigate(
                `/daftarPengajuanFidusia/pengajuanFidusia/${id}/editDetail`
              );
            }}
          >
            Ubah Detail
          </Button>
          <Button
            color="warning"
            startIcon={<PanoramaIcon />}
            sx={{ textTransform: "none" }}
            onClick={() => {
              navigate(
                `/daftarPengajuanFidusia/pengajuanFidusia/${id}/editFoto`
              );
            }}
          >
            Ubah Foto
          </Button>
        </ButtonGroup>
      </Box>

      {id && previewPdfFormulir && (
        <div>
          <Button
            variant="outlined"
            startIcon={<PrintIcon />}
            onClick={generatePDF}
          >
            CETAK
          </Button>
          <div ref={reportTemplateRef} style={cetakContainer}>
            {/* Halaman 1 */}
            <div style={cetakPage}>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <img
                  src={LogoPerusahaanSpFidusiaBlackAndWhite}
                  alt="LogoPerusahaanSpFidusiaBlackAndWhite"
                  style={{ width: "400px" }}
                />
              </div>
              <p style={cetakCenter}>FORMULIR PERMOHONAN AKAD KREDIT</p>

              <div style={{ display: "flex" }}>
                <div style={{ flex: 1 }}>
                  <div style={{ border: "1px solid black" }}>
                    <div style={cetakTitle}>
                      <b>DATA PEMOHON</b>
                    </div>
                    <div>
                      <div style={formulirDataWrapper}>
                        <div style={{ flex: 1 }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>Nama Lengkap (Sesuai KTP)</p>
                          </div>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>No. Identitas</p>
                          </div>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>Nama Panggilan</p>
                          </div>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>Tempat /Tanggal Lahir</p>
                          </div>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>Status</p>
                          </div>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>Jumlah Tanggungan</p>
                          </div>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>Alamat KTP</p>
                          </div>
                        </div>
                        <div style={{ flex: 1.5 }}>
                          <div style={{ display: "flex" }}>
                            <div style={formulirTextFieldContainer}>
                              <p style={textStyle}>:</p>
                            </div>
                            <div style={formulirTextValueContainer}>
                              <p style={textStyle}>
                                {namaCustomerSurvey &&
                                  namaCustomerSurvey.slice(0, 36)}
                              </p>
                            </div>
                          </div>
                          <div style={{ display: "flex" }}>
                            <div style={formulirTextFieldContainer}>
                              <p style={textStyle}>:</p>
                            </div>
                            <div style={formulirTextValueContainer}>
                              <p style={textStyle}>
                                {nikCustomerSurvey &&
                                  nikCustomerSurvey.slice(0, 36)}
                              </p>
                            </div>
                          </div>
                          <div style={{ display: "flex" }}>
                            <div style={formulirTextFieldContainer}>
                              <p style={textStyle}>:</p>
                            </div>
                            <div style={formulirTextValueContainer}>
                              <p style={textStyle}>
                                {namaPanggilanCustomerSurvey &&
                                  namaPanggilanCustomerSurvey.slice(0, 36)}
                              </p>
                            </div>
                          </div>
                          <div style={{ display: "flex" }}>
                            <div style={formulirTextFieldContainer}>
                              <p style={textStyle}>:</p>
                            </div>
                            <div style={formulirTextValueContainer}>
                              <p style={textStyle}>
                                {tempatLahirCustomerSurvey &&
                                  tempatLahirCustomerSurvey.slice(0, 24)}
                                , {tanggalLahirCustomerSurvey}
                              </p>
                            </div>
                          </div>
                          <div style={{ display: "flex" }}>
                            <div style={formulirTextFieldContainer}>
                              <p style={textStyle}>:</p>
                            </div>
                            <div style={formulirTextValueContainer}>
                              <p style={textStyle}>
                                {statusPerkawinanCustomerSurvey &&
                                  statusPerkawinanCustomerSurvey.slice(0, 36)}
                              </p>
                            </div>
                          </div>
                          <div style={{ display: "flex" }}>
                            <div style={formulirTextFieldContainer}>
                              <p style={textStyle}>:</p>
                            </div>
                            <div style={formulirTextValueContainer}>
                              <p style={textStyle}></p>
                            </div>
                          </div>
                          <div style={{ display: "flex" }}>
                            <div style={formulirTextFieldContainer}>
                              <p style={textStyle}>:</p>
                            </div>
                            <div style={formulirTextValueContainer}>
                              <p style={textStyle}>
                                {alamatCustomerSurvey &&
                                  alamatCustomerSurvey.slice(0, 30)}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div style={formulirDataAlamat}>
                        <p style={textStyle}>
                          {alamatCustomerSurvey &&
                            alamatCustomerSurvey.slice(30, 30 + 65)}
                        </p>
                      </div>
                      <div style={formulirDataAlamat}>
                        <p style={textStyle}>
                          {alamatCustomerSurvey &&
                            alamatCustomerSurvey.slice(30 + 65, 30 + 65 + 65)}
                        </p>
                      </div>
                      <div style={formulirDataWrapper}>
                        <div style={{ flex: 1 }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>Alamat Sekarang</p>
                          </div>
                        </div>
                        <div style={{ flex: 1.5 }}>
                          <div style={{ display: "flex" }}>
                            <div style={formulirTextFieldContainer}>
                              <p style={textStyle}>:</p>
                            </div>
                            <div style={formulirTextValueContainer}>
                              <p style={textStyle}>
                                {alamatTTCustomerSurvey &&
                                  alamatTTCustomerSurvey.slice(0, 30)}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div style={formulirDataAlamat}>
                        <p style={textStyle}>
                          {alamatTTCustomerSurvey &&
                            alamatTTCustomerSurvey.slice(30, 30 + 65)}
                        </p>
                      </div>
                      <div style={formulirDataAlamat}>
                        <p style={textStyle}>
                          {alamatTTCustomerSurvey &&
                            alamatTTCustomerSurvey.slice(30 + 65, 30 + 65 + 65)}
                        </p>
                      </div>
                      <div style={formulirDataWrapper}>
                        <div style={{ flex: 1 }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>No. Telp/HP 1</p>
                          </div>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>No. Telp/HP 2</p>
                          </div>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>Nama Gadis Ibu Kandung</p>
                          </div>
                        </div>
                        <div style={{ flex: 1.5 }}>
                          <div style={{ display: "flex" }}>
                            <div style={formulirTextFieldContainer}>
                              <p style={textStyle}>:</p>
                            </div>
                            <div style={formulirTextValueContainer}>
                              <p style={textStyle}>
                                {noTeleponCustomerSurvey &&
                                  noTeleponCustomerSurvey.slice(0, 36)}
                              </p>
                            </div>
                          </div>
                          <div style={{ display: "flex" }}>
                            <div style={formulirTextFieldContainer}>
                              <p style={textStyle}>:</p>
                            </div>
                            <div style={formulirTextValueContainer}>
                              <p style={textStyle}></p>
                            </div>
                          </div>
                          <div style={{ display: "flex" }}>
                            <div style={formulirTextFieldContainer}>
                              <p style={textStyle}>:</p>
                            </div>
                            <div style={formulirTextValueContainer}>
                              <p style={textStyle}></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div style={{ border: "1px solid black", marginTop: "20px" }}>
                    <div style={cetakTitle}>
                      <b>DATA PEKERJAAN</b>
                    </div>
                    <div style={formulirDataWrapper}>
                      <div style={{ flex: 1 }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Nama Perusahaan/Usaha</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Bidang Usaha</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Bagian/Jabatan</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Alamat Perusahaan/Usaha</p>
                        </div>
                      </div>
                      <div style={{ flex: 1.5 }}>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {namaPerusahaanCustomerSurvey &&
                                namaPerusahaanCustomerSurvey.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {bidangUsahaCustomerSurvey &&
                                bidangUsahaCustomerSurvey.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {jabatanCustomerSurvey &&
                                jabatanCustomerSurvey.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {alamatPerusahaanCustomerSurvey &&
                                alamatPerusahaanCustomerSurvey.slice(0, 30)}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={formulirDataAlamat}>
                      <p style={textStyle}>
                        {alamatPerusahaanCustomerSurvey &&
                          alamatPerusahaanCustomerSurvey.slice(30, 30 + 65)}
                      </p>
                    </div>
                    <div style={formulirDataAlamat}>
                      <p style={textStyle}>
                        {alamatPerusahaanCustomerSurvey &&
                          alamatPerusahaanCustomerSurvey.slice(
                            30 + 65,
                            30 + 65 + 65
                          )}
                      </p>
                    </div>
                    <div style={formulirDataWrapper}>
                      <div style={{ flex: 1 }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>No. Telp Perusahaan</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Lama Kerja / Status</p>
                        </div>
                      </div>
                      <div style={{ flex: 1.5 }}>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {noTeleponPerusahaanCustomerSurvey}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {lamaKerjaCustomerSurvey &&
                                lamaKerjaCustomerSurvey.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={formulirDataWrapper}>
                      <div style={{ flex: 1 }}>
                        <div
                          style={{
                            height: "104px",
                            border: "1px solid black",
                            paddingTop: "40px",
                          }}
                        >
                          <p style={textStyle}>Besaran Gaji dalam setahun</p>
                        </div>
                      </div>
                      <div style={{ flex: 1.5 }}>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyleHidden}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <div style={{ display: "flex" }}>
                              <div style={boxStyle}></div>
                              <div>
                                <p style={textStyle}>{"< 50 Juta"}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyleHidden}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <div style={{ display: "flex" }}>
                              <div style={boxStyle}></div>
                              <div>
                                <p style={textStyle}>{"50 Juta - 75 Juta"}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyleHidden}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <div style={{ display: "flex" }}>
                              <div style={boxStyle}></div>
                              <div>
                                <p style={textStyle}>{"75 Juta - 100 Juta"}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyleHidden}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <div style={{ display: "flex" }}>
                              <div style={boxStyle}></div>
                              <div>
                                <p style={textStyle}>{"> 100 Juta"}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={formulirDataWrapper}>
                      <div style={{ flex: 1 }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Pendapatan Lain</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Nama Atasan Langsung</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Alamat Atasan</p>
                        </div>
                      </div>
                      <div style={{ flex: 1.5 }}>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {pendapatanLainCustomerSurvey.toLocaleString(
                                "de-DE"
                              )}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}></p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}></p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={formulirDataAlamat}>
                      <p style={textStyle}></p>
                    </div>
                    <div style={formulirDataWrapper}>
                      <div style={{ flex: 1 }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>No. Telp/HP</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Pekerjaan/Alamat</p>
                        </div>
                      </div>
                      <div style={{ flex: 1.5 }}>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {noTeleponPerusahaanCustomerSurvey &&
                                noTeleponPerusahaanCustomerSurvey.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {alamatPerusahaanCustomerSurvey &&
                                alamatPerusahaanCustomerSurvey.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={formulirDataAlamat}>
                      <p style={textStyle}></p>
                    </div>
                  </div>
                </div>
                <div style={{ flex: 1, marginLeft: "20px" }}>
                  <div style={{ border: "1px solid black" }}>
                    <div style={cetakTitle}>
                      <b>DATA KENDARAAN</b>
                    </div>
                  </div>
                  <div style={formulirDataWrapper}>
                    <div style={{ flex: 1 }}>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>Merek</p>
                      </div>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>Type</p>
                      </div>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>Tahun</p>
                      </div>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>Warna</p>
                      </div>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>No. Polisi</p>
                      </div>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>No. Rangka</p>
                      </div>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>No. Mesin</p>
                      </div>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>Masa Berlaku STNK</p>
                      </div>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>Nama BPKB</p>
                      </div>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>Alamat BPKB</p>
                      </div>
                    </div>
                    <div style={{ flex: 1.5 }}>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>
                            {merkSurvey && merkSurvey.slice(0, 36)}
                          </p>
                        </div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>
                            {tipeSurvey && tipeSurvey.slice(0, 36)}
                          </p>
                        </div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>
                            {tahunSurvey && tahunSurvey.slice(0, 36)}
                          </p>
                        </div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>
                            {warnaSurvey && warnaSurvey.slice(0, 36)}
                          </p>
                        </div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>
                            {nopolSurvey && nopolSurvey.slice(0, 36)}
                          </p>
                        </div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>
                            {noRangkaSurvey && noRangkaSurvey.slice(0, 36)}
                          </p>
                        </div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>
                            {noMesinSurvey && noMesinSurvey.slice(0, 36)}
                          </p>
                        </div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>{tglStnkSurvey}</p>
                        </div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>
                            {bpkbANSurvey && bpkbANSurvey.slice(0, 36)}
                          </p>
                        </div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>
                            {bpkbAlamatSurvey && bpkbAlamatSurvey.slice(0, 36)}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style={formulirDataAlamat}>
                    <p style={textStyle}></p>
                  </div>
                  <div style={formulirDataAlamat}>
                    <p style={textStyle}></p>
                  </div>

                  <div style={{ border: "1px solid black", marginTop: "20px" }}>
                    <div style={cetakTitle}>
                      <b>DATA PEMBIAYAAN / STRUKTUR KREDIT</b>
                    </div>
                    <div style={formulirDataWrapper}>
                      <div style={{ flex: 1 }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Harga OTR</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Uang Muka</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Pokok Hutang</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Angsuran</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Jangka Waktu</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Tanggal Jatuh Tempo</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Tujuan Penggunaan Dana</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Pendingan/Pengurusan</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Sumber Order</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Nama Surveyor</p>
                        </div>
                      </div>
                      <div style={{ flex: 1.5 }}>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              Rp. {hargaOtrSurvey.toLocaleString("de-DE")}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              Rp. {uangMukaSurvey.toLocaleString("de-DE")}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              Rp. {pinjamanAjuSurvey.toLocaleString("de-DE")}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              Rp. {angPerBulanSurvey.toLocaleString("de-DE")}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {tenorSurvey.toLocaleString("de-DE")} BULAN
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {tglJtTempoSurvey && tglJtTempoSurvey.slice(0, 2)}{" "}
                              SETIAP BULAN
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {tujuanPenggunaanDanaSurvey &&
                                tujuanPenggunaanDanaSurvey.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {pendinganPengurusanSurvey &&
                                pendinganPengurusanSurvey.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {kodeMarketingSurvey &&
                                kodeMarketingSurvey.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {kodeSurveyorSurvey &&
                                kodeSurveyorSurvey.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div style={{ border: "1px solid black", marginTop: "20px" }}>
                    <div style={cetakTitle}>
                      <b>DATA PENJAMIN</b>
                    </div>
                    <div style={formulirDataWrapper}>
                      <div style={{ flex: 1 }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>No. Identitas</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Nama Lengkap (Sesuai KTP)</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Tempat /Tanggal Lahir</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>No. Telp/HP</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Alamat Sekarang</p>
                        </div>
                      </div>
                      <div style={{ flex: 1.5 }}>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {nikPenjaminSurvey &&
                                nikPenjaminSurvey.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {namaPenjaminSurvey &&
                                namaPenjaminSurvey.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {tempatLahirPenjaminSurvey &&
                                tempatLahirPenjaminSurvey.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {noTeleponPenjaminSurvey &&
                                noTeleponPenjaminSurvey.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {alamatPenjaminSurvey &&
                                alamatPenjaminSurvey.slice(0, 30)}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style={formulirDataAlamat}>
                    <p style={textStyle}>
                      {alamatPenjaminSurvey &&
                        alamatPenjaminSurvey.slice(30, 30 + 65)}
                    </p>
                  </div>
                  <div style={formulirDataAlamat}>
                    <p style={textStyle}>
                      {alamatPenjaminSurvey &&
                        alamatPenjaminSurvey.slice(30 + 65, 30 + 65 + 65)}
                    </p>
                  </div>
                  <div style={formulirDataWrapper}>
                    <div style={{ flex: 1 }}>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>Nama Perusahaan/Usaha</p>
                      </div>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>Alamat Perusahaan/Usaha</p>
                      </div>
                    </div>
                    <div style={{ flex: 1.5 }}>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>
                            {namaPerusahaanPenjaminSurvey &&
                              namaPerusahaanPenjaminSurvey.slice(0, 36)}
                          </p>
                        </div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>
                            {alamatPerusahaanPenjaminSurvey &&
                              alamatPerusahaanPenjaminSurvey.slice(0, 30)}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style={formulirDataAlamat}>
                    <p style={textStyle}>
                      {alamatPerusahaanPenjaminSurvey &&
                        alamatPerusahaanPenjaminSurvey.slice(30, 30 + 65)}
                    </p>
                  </div>
                  <div style={formulirDataAlamat}>
                    <p style={textStyle}>
                      {alamatPerusahaanPenjaminSurvey &&
                        alamatPerusahaanPenjaminSurvey.slice(
                          30 + 65,
                          30 + 65 + 65
                        )}
                    </p>
                  </div>
                  <div style={formulirDataWrapper}>
                    <div style={{ flex: 1 }}>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>Bagian/Jabatan</p>
                      </div>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>Lama Kerja</p>
                      </div>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>Hubungan Penjamin</p>
                      </div>
                    </div>
                    <div style={{ flex: 1.5 }}>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>
                            {pekerjaanPenjaminSurvey &&
                              pekerjaanPenjaminSurvey.slice(0, 36)}
                          </p>
                        </div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>
                            {lamaKerjaPenjaminSurvey &&
                              lamaKerjaPenjaminSurvey.slice(0, 36)}
                          </p>
                        </div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>
                            {hubunganPenjaminSurvey &&
                              hubunganPenjaminSurvey.slice(0, 36)}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ marginTop: "20px" }}>
                <div>
                  <div style={cetakTitle}>
                    <b>KETERANGAN LAIN</b>
                  </div>
                </div>
                <div style={{ border: "1px solid black", height: "120px" }}>
                  <p style={textStyle}>
                    {keteranganSurvey && keteranganSurvey.slice(0, 135)}
                  </p>
                  <p style={textStyle}>
                    {keteranganSurvey && keteranganSurvey.slice(135, 270)}
                  </p>
                  <p style={textStyle}>
                    {keteranganSurvey && keteranganSurvey.slice(270, 405)}
                  </p>
                  <p style={textStyle}>
                    {keteranganSurvey && keteranganSurvey.slice(405, 540)}
                  </p>
                </div>
              </div>

              <div style={{ marginTop: "20px" }}>
                <div style={{ fontSize: "10px", fontWeight: "bold" }}>
                  <p style={textStyle}>
                    Catatan : Apabila Permohonan sudah disetujui Pemohon dan
                    Penjamin bersedia dan sanggup
                  </p>
                  <div style={{ marginLeft: "80px" }}>
                    <p style={textStyle}>
                      mentaati segala peraturan dan perjanjian yang telah
                      ditetapkan oleh perusahaan
                    </p>
                  </div>
                  <p style={textStyle}>* Coret yang tidak perlu</p>
                </div>
              </div>
            </div>

            {/* Halaman 2 */}
            <div style={cetakPage}>
              <div style={{ marginTop: "20px" }}>
                <p style={cetakCenter}>DENAH NASABAH & DATA REFERENSI</p>
              </div>

              <div style={{ display: "flex", marginTop: "20px" }}>
                <div style={{ flex: 1 }}>
                  <div style={{ border: "1px solid black" }}>
                    <div style={cetakTitle}>
                      <b>DATA REFERENSI</b>
                    </div>
                    <div style={formulirDataWrapper}>
                      <div style={{ flex: 1 }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Nama</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Hubungan</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Status</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Alamat Tempat Tinggal</p>
                        </div>
                      </div>
                      <div style={{ flex: 1.5 }}>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {namaRefRegisterSurvey &&
                                namaRefRegisterSurvey.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {hubunganRefRegisterSurvey &&
                                hubunganRefRegisterSurvey.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {/* {statusPerkawinanRefRegisterSurvey &&
                                statusPerkawinanRefRegisterSurvey.slice(0, 36)} */}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {alamatRefRegisterSurvey &&
                                alamatRefRegisterSurvey.slice(0, 30)}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={formulirDataAlamat}>
                      <p style={textStyle}>
                        {alamatRefRegisterSurvey &&
                          alamatRefRegisterSurvey.slice(30, 30 + 65)}
                      </p>
                    </div>
                    <div style={formulirDataWrapper}>
                      <div style={{ flex: 1 }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>No. Telp/HP</p>
                        </div>
                      </div>
                      <div style={{ flex: 1.5 }}>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {teleponRefRegisterSurvey &&
                                teleponRefRegisterSurvey.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={formulirDataAlamat}>
                      <p style={textStyle}></p>
                    </div>
                  </div>

                  <div style={{ border: "1px solid black", marginTop: "20px" }}>
                    <div style={cetakTitle}>
                      <b>DATA REFERENSI</b>
                    </div>
                    <div style={formulirDataWrapper}>
                      <div style={{ flex: 1 }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Nama</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Hubungan</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Status</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Alamat Tempat Tinggal</p>
                        </div>
                      </div>
                      <div style={{ flex: 1.5 }}>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {namaRef3RegisterSurvey &&
                                namaRef3RegisterSurvey.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {hubunganRef3RegisterSurvey &&
                                hubunganRef3RegisterSurvey.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {/* {statusPerkawinanRef3RegisterSurvey &&
                                statusPerkawinanRef3RegisterSurvey.slice(0, 36)} */}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {alamatRef3RegisterSurvey &&
                                alamatRef3RegisterSurvey.slice(0, 30)}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={formulirDataAlamat}>
                      <p style={textStyle}>
                        {alamatRef3RegisterSurvey &&
                          alamatRef3RegisterSurvey.slice(30, 30 + 65)}
                      </p>
                    </div>
                    <div style={formulirDataWrapper}>
                      <div style={{ flex: 1 }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>No. Telp/HP</p>
                        </div>
                      </div>
                      <div style={{ flex: 1.5 }}>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {teleponRef3RegisterSurvey &&
                                teleponRef3RegisterSurvey.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={formulirDataAlamat}>
                      <p style={textStyle}></p>
                    </div>
                  </div>
                </div>
                <div style={{ flex: 1, marginLeft: "20px" }}>
                  <div style={{ border: "1px solid black" }}>
                    <div style={cetakTitle}>
                      <b>DATA REFERENSI</b>
                    </div>
                    <div style={formulirDataWrapper}>
                      <div style={{ flex: 1 }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Nama</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Hubungan</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Status</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Alamat Tempat Tinggal</p>
                        </div>
                      </div>
                      <div style={{ flex: 1.5 }}>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {namaRef2RegisterSurvey &&
                                namaRef2RegisterSurvey.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {hubunganRef2RegisterSurvey &&
                                hubunganRef2RegisterSurvey.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {/* {statusPerkawinanRef2RegisterSurvey &&
                                statusPerkawinanRef2RegisterSurvey.slice(0, 36)} */}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {alamatRef2RegisterSurvey &&
                                alamatRef2RegisterSurvey.slice(0, 30)}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={formulirDataAlamat}>
                      <p style={textStyle}>
                        {alamatRef2RegisterSurvey &&
                          alamatRef2RegisterSurvey.slice(30, 30 + 65)}
                      </p>
                    </div>
                    <div style={formulirDataWrapper}>
                      <div style={{ flex: 1 }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>No. Telp/HP</p>
                        </div>
                      </div>
                      <div style={{ flex: 1.5 }}>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {teleponRef2RegisterSurvey &&
                                teleponRef2RegisterSurvey.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={formulirDataAlamat}>
                      <p style={textStyle}></p>
                    </div>
                  </div>
                </div>
              </div>

              <div
                style={{
                  marginTop: "40px",
                  marginBottom: "20px",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                }}
              >
                <p style={textStyle}>{keteranganSurvey}</p>
              </div>

              <div style={{ marginLeft: "600px", fontWeight: "bold" }}>
                <div style={{ display: "flex" }}>
                  <p style={textStyle}>Batam,</p>
                  <div
                    style={{
                      marginLeft: "20px",
                      borderBottom: "1px solid black",
                      width: "160px",
                    }}
                  ></div>
                </div>
                <div style={{ marginLeft: "75px" }}>
                  <p style={textStyle}>Hormat Saya</p>
                </div>
                <div style={{ height: "100px", marginLeft: "75px" }}>
                  <img
                    src={ttdSurveySurvey}
                    alt="Base64 Image"
                    style={{ maxWidth: "100%", maxHeight: "100%" }}
                  />
                </div>
                <div
                  style={{
                    marginLeft: "75px",
                    borderBottom: "1px solid black",
                    width: "160px",
                  }}
                >
                  <p style={textStyle}>Nama</p>
                </div>
                <div style={{ marginLeft: "75px" }}>
                  <p style={textStyle}>Pemohon</p>
                </div>
              </div>

              <div style={{ marginTop: "20px" }}>
                <div style={{ height: "300px" }}>
                  <img
                    src={denahLokasiSurveySurvey}
                    alt="Base64 Image"
                    style={{ maxWidth: "100%" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {gambar.length !== 0 && (
        <Box sx={showDataContainer}>
          {gambar && (
            <Carousel breakPoints={breakPoints} sx={carouselStyle}>
              {gambar &&
                gambar.map((img, i) => (
                  <Card sx={oldImageCard} elevation={10}>
                    <CardActionArea disableRipple>
                      <CardHeader title={`Gambar`} subheader={`No. ${i + 1}`} />
                      <CardMedia
                        component="img"
                        height="100%"
                        src={img.linkGambar}
                        alt="gambar"
                        sx={oldImageCardMedia}
                        onClick={() => {
                          window.open(
                            img.linkGambar,
                            "_blank",
                            "noopener,noreferrer"
                          );
                        }}
                      />
                    </CardActionArea>
                  </Card>
                ))}
            </Carousel>
          )}
        </Box>
      )}

      <Form>
        <Card>
          <Card.Header>Data Pribadi Nasabah</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        NIK / CIF :
                      </Form.Label>
                      <Col sm="4">
                        <Form.Control value={nikCustomer} disabled readOnly />
                      </Col>
                      <Col sm="4">
                        <Form.Control
                          required
                          value={cifCustomer}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        No. KK :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control value={noKkCustomer} disabled readOnly />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Nama :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          as="textarea"
                          rows={3}
                          value={namaCustomer}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Tempat Lahir :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          value={tempatLahirCustomer}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Tgl. Lahir :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          value={tanggalLahirCustomer}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Jenis Kelamin :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          value={jenisKelaminCustomer}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Agama :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control value={agamaCustomer} disabled readOnly />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        No. Telp / HP :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          value={noTeleponCustomer}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Status Perkawinan :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          value={statusPerkawinanCustomer}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Kewarganegaraan :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          value={kewarganegaraanCustomer}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Jenis Resiko :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          value={jenisResikoAju}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Pekerjaan :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          value={pekerjaanCustomer}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Jabatan / Posisi :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          value={jabatanCustomer}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Link Map :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          value={linkMapsSurvey}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Tujuan Penggunaan Dana :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          value={tujuanPenggunaanDana}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Card style={{ marginTop: 10, marginBottom: 10 }}>
                  <Card.Header>Tingkat Risiko</Card.Header>
                  <Card.Body>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="4" style={textRight}>
                            Kelompok Kerja :
                          </Form.Label>
                          <Col sm="8">
                            <Form.Control
                              value={tingkatRisiko}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="4" style={textRight}>
                            TPPU :
                          </Form.Label>
                          <Col sm="8">
                            <Form.Control
                              value={findTingkatRisiko(
                                tingkatRisikoData.tppuTingkatRisiko
                              )}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="4" style={textRight}>
                            TPPT :
                          </Form.Label>
                          <Col sm="8">
                            <Form.Control
                              value={findTingkatRisiko(
                                tingkatRisikoData.tpptTingkatRisiko
                              )}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="4" style={textRight}>
                            PPSPM :
                          </Form.Label>
                          <Col sm="8">
                            <Form.Control
                              value={findTingkatRisiko(
                                tingkatRisikoData.ppspmTingkatRisiko
                              )}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Keterangan :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control value={ketResikoAju} disabled readOnly />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}>
                <Card>
                  <Card.Header>Alamat (Identitas)</Card.Header>
                  <Card.Body>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="4" style={textRight}>
                            Alamat :
                          </Form.Label>
                          <Col sm="8">
                            <Form.Control
                              as="textarea"
                              rows={3}
                              value={alamatCustomer}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="4" style={textRight}>
                            Kel. / Desa :
                          </Form.Label>
                          <Col sm="8">
                            <Form.Control
                              value={kodeKelurahan}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="4" style={textRight}>
                            Kecamatan :
                          </Form.Label>
                          <Col sm="8">
                            <Form.Control
                              value={kodeKecamatan}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="4" style={textRight}>
                            Kabupaten / Kota :
                          </Form.Label>
                          <Col sm="8">
                            <Form.Control
                              value={kodeKabupaten}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="4" style={textRight}>
                            Provinsi :
                          </Form.Label>
                          <Col sm="8">
                            <Form.Control
                              value={kodeProvinsi}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="4" style={textRight}>
                            Kode POS :
                          </Form.Label>
                          <Col sm="8">
                            <Form.Control value={kodePos} disabled readOnly />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
                <Card style={{ marginTop: "10px" }}>
                  <Card.Header>Tempat Tinggal</Card.Header>
                  <Card.Body>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="4" style={textRight}>
                            Alamat :
                          </Form.Label>
                          <Col sm="8">
                            <Form.Control
                              as="textarea"
                              rows={3}
                              value={alamatTTCustomer}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="4" style={textRight}>
                            Kel. / Desa :
                          </Form.Label>
                          <Col sm="8">
                            <Form.Control
                              value={kodeKelurahanTT}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="4" style={textRight}>
                            Kecamatan :
                          </Form.Label>
                          <Col sm="8">
                            <Form.Control
                              value={kodeKecamatanTT}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="4" style={textRight}>
                            Kabupaten / Kota :
                          </Form.Label>
                          <Col sm="8">
                            <Form.Control
                              value={kodeKabupatenTT}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="4" style={textRight}>
                            Provinsi :
                          </Form.Label>
                          <Col sm="8">
                            <Form.Control
                              value={kodeProvinsiTT}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="4" style={textRight}>
                            Kode POS :
                          </Form.Label>
                          <Col sm="8">
                            <Form.Control value={kodePosTT} disabled readOnly />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Box>
            </Box>
          </Card.Body>
        </Card>

        <Card style={{ marginTop: 10 }}>
          <Card.Header>Data Penjamin</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        NIK :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          required
                          value={nikPenjamin}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        No. KK :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          required
                          value={noKkPenjamin}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Nama :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          as="textarea"
                          rows={3}
                          required
                          value={namaPenjamin}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Tempat Lahir :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          required
                          value={tempatLahirPenjamin}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Tgl. Lahir :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          required
                          value={tanggalLahirPenjamin}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Jenis Kelamin :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          required
                          value={jenisKelaminPenjamin}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Agama :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          required
                          value={agamaPenjamin}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        No. Telp / HP :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          required
                          value={noTeleponPenjamin}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Status Perkawinan :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          required
                          value={statusPerkawinanPenjamin}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Pekerjaan :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          required
                          value={pekerjaanPenjamin}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Kewarganegaraan :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          required
                          value={kewarganegaraanPenjamin}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}>
                <Card>
                  <Card.Header>Alamat (Identitas)</Card.Header>
                  <Card.Body>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="4" style={textRight}>
                            Alamat :
                          </Form.Label>
                          <Col sm="8">
                            <Form.Control
                              as="textarea"
                              rows={3}
                              required
                              value={alamatPenjamin}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="4" style={textRight}>
                            Kel. / Desa :
                          </Form.Label>
                          <Col sm="8">
                            <Form.Control
                              required
                              value={kodeKelurahanPenjamin}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="4" style={textRight}>
                            Kecamatan :
                          </Form.Label>
                          <Col sm="8">
                            <Form.Control
                              required
                              value={kodeKecamatanPenjamin}
                              readOnly
                              disabled
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="4" style={textRight}>
                            Kabupaten / Kota :
                          </Form.Label>
                          <Col sm="8">
                            <Form.Control
                              required
                              value={kodeKabupatenPenjamin}
                              readOnly
                              disabled
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="4" style={textRight}>
                            Provinsi :
                          </Form.Label>
                          <Col sm="8">
                            <Form.Control
                              required
                              value={kodeProvinsiPenjamin}
                              readOnly
                              disabled
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="4" style={textRight}>
                            Kode POS :
                          </Form.Label>
                          <Col sm="8">
                            <Form.Control
                              required
                              value={kodePosPenjamin}
                              readOnly
                              disabled
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Box>
            </Box>
          </Card.Body>
        </Card>

        {/* Data Referensi */}
        <Card style={{ marginTop: "20px" }}>
          <Card.Header>Data Referensi</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Nama Ref. Register :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control disabled value={namaRefRegister} />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Telepon Ref. Register :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control disabled value={teleponRefRegister} />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Alamat Ref. Register :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control disabled value={alamatRefRegister} />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Hubungan dengan Nasabah :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control disabled value={hubunganRefRegister} />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                {/* <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Status Perkawinan :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          disabled
                          value={statusPerkawinanRefRegister}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row> */}

                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Nama Ref. Register 2 :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control disabled value={namaRef2Register} />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Telepon Ref. Register 2 :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control disabled value={teleponRef2Register} />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Alamat Ref. Register 2 :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control disabled value={alamatRef2Register} />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Hubungan dengan Nasabah 2 :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control disabled value={hubunganRef2Register} />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                {/* <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Status Perkawinan :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          disabled
                          value={statusPerkawinanRef2Register}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row> */}

                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Nama Ref. Register 3 :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control disabled value={namaRef3Register} />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Telepon Ref. Register 3 :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control disabled value={teleponRef3Register} />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Alamat Ref. Register 3 :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control disabled value={alamatRef3Register} />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Hubungan dengan Nasabah 3 :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control disabled value={hubunganRef3Register} />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                {/* <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Status Perkawinan :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          disabled
                          value={statusPerkawinanRef3Register}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row> */}
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>
          </Card.Body>
        </Card>

        <Card style={{ marginTop: 10 }}>
          <Card.Header>Data Pinjaman</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        No. Pengajuan :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control value={noAju} disabled readOnly />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        No. Perjanjian :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control value={noPerjanjian} disabled readOnly />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Pinjaman Rp. :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          required
                          value={pinjamanAju.toLocaleString("de-DE")}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Angsuran/Bulan :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          required
                          value={angPerBulan.toLocaleString("de-DE")}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Tenor :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          required
                          value={tenor}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Bunga/Tahun :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          required
                          value={bungaPerTahun.toLocaleString("de-DE")}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Total Piutang :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          value={totalPiutang.toLocaleString("de-DE")}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Tanggal :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          required
                          value={tanggalAju}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Tgl. Ang 1 :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          required
                          value={tglAng}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Tgl. Ang Akhir :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          required
                          value={tglAngAkhir}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Kategori :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          required
                          value={kategori}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Surveyor :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          required
                          value={kodeSurveyor}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Marketing :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          required
                          value={kodeMarketing}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Kode Kas :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control value={kodeCOA} disabled readOnly />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
            </Box>
          </Card.Body>
        </Card>

        <Card style={{ marginTop: 10 }}>
          <Card.Header>Data Kendaraan</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Tipe :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          required
                          value={kodeTipe}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Tahun :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          required
                          value={tahun}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        No. Rangka :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control value={noRangka} disabled readOnly />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        No. Mesin :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control value={noMesin} disabled readOnly />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        No. Polisi :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          required
                          value={nopol}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Warna :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          required
                          value={kodeWarna}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Merk :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control value={merk} disabled readOnly />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        CC :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control value={isi} disabled readOnly />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Tgl. Stnk :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          required
                          value={tglStnk}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        No. BPKP :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          required
                          value={noBpkb}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        BPKP A/N :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          required
                          value={bpkbAN}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
            </Box>
          </Card.Body>
        </Card>

        <Card style={{ marginTop: 10 }}>
          <Card.Header>Data Penilaian</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="7" style={textRight}>
                        Harga Pasar Setempat/Otr :
                      </Form.Label>
                      <Col sm="5">
                        <Form.Control
                          required
                          value={hargaPasarSetempatOtr.toLocaleString("de-DE")}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="7" style={textRight}>
                        Taksiran :
                      </Form.Label>
                      <Col sm="5">
                        <Form.Control
                          required
                          value={taksiran.toLocaleString("de-DE")}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="7" style={textRight}>
                        Maksimal Pemberian Pinjaman :
                      </Form.Label>
                      <Col sm="5">
                        <Form.Control
                          required
                          value={maksimalPemberianPinjaman.toLocaleString(
                            "de-DE"
                          )}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>
          </Card.Body>
        </Card>

        <Card style={{ marginTop: 10 }}>
          <Card.Header>Asuransi</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        No. Fidusia :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control value={noFidusia} disabled readOnly />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Nilai Pertanggungan :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          required
                          value={nilaiPertanggungan.toLocaleString("de-DE")}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        No. Asuransi :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control value={noAsuransi} disabled readOnly />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
            </Box>
          </Card.Body>
        </Card>

        {/* Keterangan */}
        <Card style={{ marginTop: "20px" }}>
          <Card.Header>Keterangan</Card.Header>
          <Card.Body>
            <Box sx={keteranganContainer}>
              <Form.Control
                disabled
                as="textarea"
                rows={3}
                value={keterangan}
              />
            </Box>
          </Card.Body>
        </Card>
      </Form>
    </Container>
  );
};

export default TampilPengajuanFidusia;

const buttonModifierContainer = {
  mt: 4,
  mb: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};

const textFieldContainer = {
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const textFieldWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: {
    md: "40vw",
  },
};

const secondWrapper = {
  marginLeft: {
    sm: 4,
  },
  marginTop: {
    sm: 0,
    xs: 4,
  },
};

const showDataContainer = {
  mt: 4,
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const carouselStyle = {
  display: "flex",
  height: "400px",
};

const oldImageCard = {
  m: "auto",
  mt: 2,
  maxWidth: "500px",
  maxHeight: "500px",
  display: "flex",
  flexDirection: "column",
};

const oldImageCardMedia = {
  display: "flex",
  maxHeight: "150px",
};

const keteranganContainer = {
  marginTop: "20px",
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const downloadButtons = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const cetakPage = {
  // border: "1px solid black",
  // height: "1600px",
  height: "1380px",
};

const cetakContainer = {
  padding: "20px",
  letterSpacing: "0.01px",
  fontSize: "10px",
  fontFamily: "sans-serif",
  width: "1000px",
};

const cetakCenter = {
  textAlign: "center",
  marginTop: "0px",
  marginBottom: "0px",
  fontWeight: "bold",
  fontSize: "10px",
};

const cetakTitle = {
  padding: "5px",
  textAlign: "center",
  fontSize: "10px",
};

const formulirDataWrapper = {
  display: "flex",
  borderTop: "1px solid black",
  paddingBottom: "0px",
  fontSize: "10px",
};

const formulirDataAlamat = {
  display: "flex",
  paddingLeft: "10px",
  paddingRight: "10px",
  fontSize: "10px",
  height: "25px",
  border: "1px solid black",
};

const formulirTextFieldContainer = {
  border: "1px solid black",
  padding: "2px",
};

const formulirTextValueContainer = {
  border: "1px solid black",
  padding: "2px",
  flex: 1,
};

const boxStyle = {
  border: "1px solid black",
  marginRight: "10px",
  height: "20px",
  width: "20px",
};

const textStyle = {
  marginBottom: 2,
};

const textStyleHidden = {
  marginBottom: 2,
  visibility: "hidden",
};
